import { makeImmutable } from "../../core";
export class CrossSellingItemType {
    constructor(params) {
        this.id = params.id;
        this.productInstance = params.productInstance;
        makeImmutable(this);
    }
}
